import { render, staticRenderFns } from "./Warning-Tip.vue?vue&type=template&id=a8a8ef04&scoped=true&"
import script from "./Warning-Tip.vue?vue&type=script&lang=js&"
export * from "./Warning-Tip.vue?vue&type=script&lang=js&"
import style0 from "./Warning-Tip.vue?vue&type=style&index=0&id=a8a8ef04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a8ef04",
  null
  
)

export default component.exports